export default __webpack_public_path__ + "static/media/green-promo-icon.d3b39f56.svg";